<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2 v-if="mode === 'CREATE'">Créer une entreprise</h2>
        <h2 v-if="mode === 'UPDATE'">Modifier une entreprise</h2>

        <b-form @submit="onSubmit" @reset="onReset" v-if="show" v-bind:validated="formSubmitted">

            <b-col cols="10">

                <b-row align-h="end" v-if="mode === 'UPDATE'">
                    <b-col cols="3">{{ libelles.dateCreation }} : {{ entreprise.createdDate | formatDate}}</b-col>
                </b-row>
                <b-row align-h="end">
                    <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-libelle" label-for="input-libelle">
                            <template v-slot:label>
                                <label-custom
                                        label="Nom de l'entreprise"
                                        tooltip="Indiquer le libellé de l'entreprise (raison sociale)"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-input
                                    id="input-libelle"
                                    v-model="entreprise.libelle"
                                    type="text"
                                    maxlength="200"
                                    :trim="true"
                                    required
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-card header="Siège">
                            <b-row>
                                <b-form-group id="input-group-siren" label-for="input-siren">
                                    <template v-slot:label>
                                        <label-custom
                                                label="SIREN"
                                                tooltip="Indiquer le numéro SIREN de l'entreprise"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-siren"
                                            v-model="entreprise.siren"
                                            type="text"
                                            maxlength="20"
                                            :formatter="formatSiretSiren"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                    <div class="typo-warning" v-if="isSirenInvalid">Attention, le SIREN entré n'est pas
                                        constitué de 9 chiffres
                                    </div>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-paysSiren" label-for="input-paysSiren">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Pays Siège"
                                                tooltip="Indiquer dans le menu déroulant dans quel pays se situe le siège social"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-select
                                            id="input-paysSiren"
                                            v-model="entreprise.paysSiren"
                                            :options="pays"
                                            @change="onPaysSirenChange"
                                            required
                                    ></b-form-select>
                                </b-form-group>
                            </b-row>
                            <b-row v-if="isFrance(entreprise.paysSiren)">
                                <b-form-group id="input-group-villeSiren" class="w-100" label-for="input-villeSiren">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Ville Siège"
                                                tooltip="Si le siège social se trouve en France, choisir la ville à partir du référentiel. Si le siège social se trouve à l'étranger, indiquer la ville manuellement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <AutocompleteCustom
                                            id="input-villeSiren"
                                            :items="communesSiren"
                                            v-model="entreprise.villeSiren"
                                            @search="searchCommunesSiren"
                                            :required="true">
                                    </AutocompleteCustom>
                                </b-form-group>
                            </b-row>
                            <b-row v-if="!isFrance(entreprise.paysSiren)">
                                <b-form-group id="input-group-villeSirenAutre" class="w-100"
                                              label-for="input-villeSirenAutre">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Ville Siège (étranger)"
                                                tooltip="Si le siège social se trouve en France, choisir la ville à partir du référentiel. Si le siège social se trouve à l'étranger, indiquer la ville manuellement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-villeSirenAutre"
                                            v-model="entreprise.villeSirenAutre"
                                            type="text"
                                            maxlength="100"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-adresseSiren" class="w-100"
                                              label-for="input-adresseSiren">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Adresse Siège"
                                                tooltip="Indiquer l'adresse postale du siège"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-adresseSiren"
                                            v-model="entreprise.adresseSiren"
                                            type="text"
                                            maxlength="200"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-card>
                    </b-col>

                    <b-col>
                        <b-card header="Agence">
                            <b-row>
                                <b-form-group id="input-group-siret" label-for="input-siret">
                                    <template v-slot:label>
                                        <label-custom
                                                label="SIRET"
                                                tooltip="Indiquer le numéro SIRET de l'établissement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-siret"
                                            v-model="entreprise.siret"
                                            type="text"
                                            maxlength="30"
                                            :formatter="formatSiretSiren"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                    <div class="typo-warning" v-if="isSiretInvalid">Attention, le SIRET entré n'est pas
                                        constitué de 14 chiffres
                                    </div>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-paysSiret" label-for="input-paysSiret">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Pays Agence"
                                                tooltip="Indiquer dans le menu déroulant dans quel pays se situe l'établissement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-select
                                            id="input-paysSiret"
                                            v-model="entreprise.paysSiret"
                                            :options="pays"
                                            @change="onPaysSiretChange"
                                            required
                                    ></b-form-select>
                                </b-form-group>
                            </b-row>
                            <b-row v-if="isFrance(entreprise.paysSiret)">
                                <b-form-group id="input-group-villeSiret" class="w-100" label-for="input-villeSiret">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Ville Agence"
                                                tooltip="Si l'établissement se trouve en France, choisir la ville à partir du référentiel. Si l'établissement se trouve à l'étranger, indiquer la ville manuellement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <AutocompleteCustom
                                            id="input-villeSiret"
                                            :items="communesSiret"
                                            v-model="entreprise.villeSiret"
                                            @search="searchCommunesSiret"
                                            :required="true">
                                    </AutocompleteCustom>
                                </b-form-group>
                            </b-row>
                            <b-row v-if="!isFrance(entreprise.paysSiret)">
                                <b-form-group id="input-group-villeSiretAutre" class="w-100"
                                              label-for="input-villeSiretAutre">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Ville Agence (étranger)"
                                                tooltip="Si l'établissement se trouve en France, choisir la ville à partir du référentiel. Si l'établissement se trouve à l'étranger, indiquer la ville manuellement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-villeSiretAutre"
                                            v-model="entreprise.villeSiretAutre"
                                            type="text"
                                            maxlength="100"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-adresseSiret" class="w-100"
                                              label-for="input-adresseSiret">
                                    <template v-slot:label>
                                        <label-custom
                                                label="Adresse Agence"
                                                tooltip="Indiquer l'adresse postale de l'établissement"
                                                :required="true">
                                        </label-custom>
                                    </template>
                                    <b-form-input
                                            id="input-adresseSiret"
                                            v-model="entreprise.adresseSiret"
                                            type="text"
                                            maxlength="200"
                                            :trim="true"
                                            required
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col>
                        <b-form-group id="input-group-ess" label-for="input-ess">
                            <template v-slot:label>
                                <label-custom
                                        label="ESS (au sens de la Loi n°2014-856 du 31 juillet 2014 relative à l’Economie Sociale et Solidaire)"
                                        tooltip="1. Structures d’insertion par l’activité économique mentionnées à l’article L. 5132-4 du code du travail et à des structures équivalentes (EI, AI, ACI, ETTI, régie de quartier,…).
2. Structure d’insertion professionnelle de personnels handicapés EA, ESAT ou structures équivalentes employant principalement des personnes handicapées.
3. Entreprise de l’économie sociale et solidaire ESS (coopérative, association loi 1901, …)."
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-radio-group
                                    id="input-ess"
                                    v-model="entreprise.ess" :buttons="true"
                                    button-variant="outline-primary"
                                    required>
                                <b-form-radio :value="true">Oui</b-form-radio>
                                <b-form-radio :value="false">Non</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="pt-2">
                    <b-modal
                            id="modal-confirm-edit"
                            title="Modification de la fiche entreprise"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            @ok="update">
                        <p>Confirmez-vous la modification de cette fiche entreprise ?</p>
                    </b-modal>
                    <b-button type="submit" variant="primary" @click="formSubmitted = true">Soumettre</b-button>
                    <b-button v-if="mode !== 'UPDATE'" type="reset" variant="danger">Réinitialiser</b-button>
                </div>

            </b-col>

        </b-form>
        <br/>
    </div>

</template>

<script>
  import EntrepriseStore from '@/stores/EntrepriseStore'
  import SaveFormEntrepriseStore from "../../stores/SaveFormEntrepriseStore";
  import InseeStore from '@/stores/InseeStore'
  import EntrepriseDto from "../../dtos/EntrepriseDto";
  import {REGEX_SIREN, REGEX_SIRET} from "../../constants/regex";
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import LabelCustom from "../../components/LabelCustom";
  import {CODE_ISO3_FRANCE} from "../../constants/common";
  import formatSiretSiren from "../../filters/formatSiretSiren";
  import AlertStore from "@/stores/AlertStore";
  import {libelles} from '../../constants/libelles';

  export default {
    components: {AutocompleteCustom, LabelCustom},
    data() {
      return {
        formSubmitted: false,
        show: true,
        entreprise: new EntrepriseDto(),
        pays: [],
        communesSiren: [],
        communesSiret: [],
        libelles: libelles
      }
    },
    computed: {
      mode() {
        return !this.$route.params.id ? 'CREATE' : 'UPDATE';
      },
      isSirenInvalid() {
        const regex = RegExp(REGEX_SIREN);
        return this.entreprise.siren && !regex.test(this.entreprise.siren);
      },
      isSiretInvalid() {
        const regex = RegExp(REGEX_SIRET);
        return this.entreprise.siret && !regex.test(this.entreprise.siret);
      },
    },
    watch: {
      $route() {
        this.initEntreprise();
      }
    },
    mounted() {
      InseeStore.getAllPays().then(
          response => this.pays = response.map(value => {
            return {text: value.libelle, value: value};
          })
      );
      this.initEntreprise();
    },
    beforeRouteLeave(_to, _from, _next) {
      if (SaveFormEntrepriseStore.state.active && SaveFormEntrepriseStore.state.route.name !== _to.name) {
        SaveFormEntrepriseStore.clear();
      }
      _next();
    },
    methods: {
      initEntreprise() {
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        });
        if (this.mode === 'UPDATE') {
          EntrepriseStore.get(this.$route.params.id).then(value => {
            if (value) {
              this.entreprise = value;
              this.communesSiren = value.villeSiren ? this.mapCommunes([value.villeSiren]) : [];
              this.communesSiret = value.villeSiret ? this.mapCommunes([value.villeSiret]) : [];
            }
          });
        } else {
          this.entreprise = new EntrepriseDto();
        }
      },
      formatSiretSiren(value) {
        return formatSiretSiren(value);
      },
      isFrance(pays) {
        return pays != null && pays.code === CODE_ISO3_FRANCE;
      },
      mapCommunes(communes) {
        return communes.map(value => {
          return {text: `${value.libelle} (${value.codePostal.length === 4 ? '0' + value.codePostal : value.codePostal})`, value: value};
        });
      },
      onPaysSirenChange() {
        if (this.isFrance(this.entreprise.paysSiren)) {
          this.entreprise.villeSirenAutre = null;
        } else {
          this.entreprise.villeSiren = null;
        }
      },
      onPaysSiretChange() {
        if (this.isFrance(this.entreprise.paysSiret)) {
          this.entreprise.villeSiretAutre = null;
        } else {
          this.entreprise.villeSiret = null;
        }
      },
      searchCommunesSiren(codePostalLibelle) {
        if (codePostalLibelle && codePostalLibelle.length >= 2) {
          InseeStore.getCommunesByCodePostalLibelle(codePostalLibelle).then(
              communes => {
                this.communesSiren = this.mapCommunes(communes);
              }
          );
        } else {
          this.communesSiren = [];
        }
      },
      searchCommunesSiret(codePostalLibelle) {
        if (codePostalLibelle && codePostalLibelle.length >= 2) {
          InseeStore.getCommunesByCodePostalLibelle(codePostalLibelle).then(
              communes => {
                this.communesSiret = this.mapCommunes(communes);
              }
          );
        } else {
          this.communesSiret = [];
        }
      },
      isValidateVille() {
         if ((this.isFrance(this.entreprise.paysSiren) && !this.entreprise.villeSiren) 
              || (this.isFrance(this.entreprise.paysSiret) && !this.entreprise.villeSiret)) {
              AlertStore.pushError("Merci de sélectionner une ville dans la liste proposée");
              return false;
         }
         return true;
      },
      onSubmit(evt) {
        if (this.isValidateVille()) {
          evt.preventDefault();
          if (this.mode !== 'UPDATE') {
            EntrepriseStore.create(this.entreprise).then(value => {
              if (SaveFormEntrepriseStore.state.active && value) {
                SaveFormEntrepriseStore.state.data = value;
                window.scrollTo(0, 0);
                this.$router.push(SaveFormEntrepriseStore.state.route.path);
              }
            });
          } else {
            this.$bvModal.show('modal-confirm-edit');
          }
        }
      },
      update() {
        EntrepriseStore.update(this.entreprise);
      },
      onReset(evt) {
        evt.preventDefault();
        this.initEntreprise();
      }
    }
  }
</script>
